import i18n from "../../resources/I18n";
import * as MENU_CONFIG from "../../util/MenuConfig";
import { getMetaTagContent } from "../../scripts/getMetaTag";
import * as ConstantesAssurabilite from "../../constants/assurabilite";

export interface IStepIndicatorProps {
  estEmprunteurPrimaire: boolean;
  estNouvelleMarge: boolean;
  estPreneurAssurance: boolean;
}

export function obtenirLibellesStepIndicator(props: IStepIndicatorProps, i18nLanguage: string): string {
  const { estEmprunteurPrimaire, estNouvelleMarge, estPreneurAssurance } = props;
  const estLangueFrancais = i18nLanguage === "fr";

  const key = (() => {
    if (estEmprunteurPrimaire) {
      if (estNouvelleMarge) return "AMC_SB_B1_NOUVELLE_MARGE";
      return estPreneurAssurance
        ? "AMC_SB_B1_CHANGEMENT_LIMITE_AVEC_ASSURANCE"
        : "AMC_SB_B1_CHANGEMENT_LIMITE_SANS_ASSURANCE";
    }
    return estNouvelleMarge ? "AMC_B2_NOUVELLE_MARGE" : "AMC_B2_CHANGEMENT_LIMITE";
  })();

  return estLangueFrancais ? MENU_CONFIG[`${key}_FR`] : MENU_CONFIG[`${key}_EN`];
}

function obtenirSousTitre(estEmprunteurPrimaire: boolean, estNouvelleMarge: boolean): string {
  if (estEmprunteurPrimaire && !estNouvelleMarge) {
    return i18n.t("amc:etape-page-questionnaire");
  }

  return estEmprunteurPrimaire
    ? i18n.t("amc:etape-page-questionnaire-7-de-9")
    : i18n.t("amc:etape-page-questionnaire-4-de-6");
}

function obtenirSousTitreMobile(estEmprunteurPrimaire: boolean, estNouvelleMarge: boolean): string {
  if (estEmprunteurPrimaire && !estNouvelleMarge) {
    return i18n.t("amc:etape-page-questionnaire");
  }

  return estEmprunteurPrimaire
    ? i18n.t("amc:etape-page-questionnaire-voir-details-7-de-9")
    : i18n.t("amc:etape-page-questionnaire-voir-details-4-de-6");
}

export default function StepIndicator(props: Readonly<IStepIndicatorProps>) {
  let isApp = getMetaTagContent("oel-is-app") === "true";

  return (
    <dsd-step-indicator
      key={props.estNouvelleMarge ? ConstantesAssurabilite.NOUVELLE : ConstantesAssurabilite.CHANGEMENT}
      substeps-numbering="false"
      steps={obtenirLibellesStepIndicator(props, i18n.language)}
      skip-to-content-id="main-content-title"
      class="dsd-w-100"
      data-testid="step-indicator"
    >
      {!isApp && (
        <span slot="title">
          {props.estNouvelleMarge
            ? i18n.t("amc:titre-indicateur-etape-nouvelle-marge")
            : i18n.t("amc:titre-indicateur-etape-changement-limite")}
        </span>
      )}
      <span slot="subtitle-mobile">{obtenirSousTitreMobile(props.estEmprunteurPrimaire, props.estNouvelleMarge)}</span>
      <span slot="subtitle">{obtenirSousTitre(props.estEmprunteurPrimaire, props.estNouvelleMarge)}</span>
    </dsd-step-indicator>
  );
}
